var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"item_body"},[_c('input',{staticClass:"tem_input",attrs:{"type":"text","placeholder":"請輸入帳號"}}),_vm._v(" "),_c('input',{staticClass:"tem_input",attrs:{"type":"text","placeholder":"請輸入密碼"}}),_vm._v(" "),_c('div',{staticClass:"com_btn",on:{"click":_vm.showMask}},[_vm._v("登入")]),_vm._v(" "),_c('div',{staticClass:"pt200"})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3ce39101","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/logins.vue
// module id = null
// module chunks = 